import { bindable } from "aurelia-framework";
import { IImportAM } from "./import-api";

export class ImportHeading {
	@bindable importEntry: IImportAM;
}
